export * as participantTypes from "./participantTypes";
export * as fieldTypes from "./fieldTypes";

export const teamNameMaxLength = 255;
